import axios from "axios";

/**
 * 續考：把作答到一半的狀態存回伺服器。
 *
 * 為什麼需要：答案原本只有交卷時才送出，計時器每次進場都從頭算。正式模考
 * 中途離開會被鎖住，教務解鎖之後學生回來——寫過的答案全沒了、時間重新開始，
 * 等於整科重考。這不是「解鎖」該有的意思。
 *
 * 存的是前端自己的狀態原樣（答案、已答題號、標記、頁碼、聽力音檔播到幾秒），
 * 伺服器不解讀內容，只負責存回來。多解讀一層只會多一個會壞掉的地方。
 */

const endpoint = (examDetailId) =>
  `${process.env.REACT_APP_EXAM_DETAILS}/${examDetailId}/progress`;

/** 剩餘秒數一律取整數且不為負，伺服器端的驗證是 integer|min:0 */
const normaliseRemaining = (remaining) =>
  Math.max(0, Math.round(Number(remaining) || 0));

export function saveProgress(examDetailId, state, remaining) {
  return axios.post(endpoint(examDetailId), {
    state: JSON.stringify(state),
    remaining: normaliseRemaining(remaining),
  });
}

/**
 * 關閉分頁／切到別的分頁的當下用 sendBeacon——那個時間點瀏覽器不保證
 * XHR 送得出去，而這一次剛好就是最需要存到的一次（正式模考會因此被鎖）。
 */
export function saveProgressBeacon(examDetailId, state, remaining) {
  if (typeof navigator === "undefined" || !navigator.sendBeacon) {
    return false;
  }
  const body = new FormData();
  body.append("state", JSON.stringify(state));
  body.append("remaining", String(normaliseRemaining(remaining)));
  return navigator.sendBeacon(endpoint(examDetailId), body);
}
